module.exports = __webpack_public_path__ + "img/text1.7e092429.png";